import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { ashlandOrConfig } from "./data";

export default function AshlandOrPage() {
  return <OregonCityPageTemplate config={ashlandOrConfig} />;
}